import React from 'react'
import PropTypes from 'prop-types'

export const ExternalLink = ({ to, linkText, className, ...rest }) => (
  <a
    className={className}
    href={to}
    target="_blank"
    rel="noopener noreferrer"
    {...rest}
  >
    {linkText}
  </a>
)

ExternalLink.propTypes = {
  to: PropTypes.string.isRequired,
  linkText: PropTypes.string.isRequired,
  className: PropTypes.string,
}
